export default __webpack_public_path__ + "2ad94683413842e52cff11dc049b3b84.glb";